// Controls display of the rotate message overlay only on mobile devices in landscape mode.
// Mobile definition: touch-capable AND viewport width below desktop breakpoint OR user agent mobile indicators.
// Landscape definition: orientation media query or width > height fallback.

const rotateMessage = {
  el: null,
  _desktopQuery: window.matchMedia('(min-width: 768px)'),
  init() {
    this.el = document.querySelector('.rotate-message');
    if (!this.el) return;
    this.update();
    window.addEventListener('resize', this._debounce(() => this.update(), 80));
    window.addEventListener('orientationchange', () => this.update());
  },
  isMobile() {
    const ua = navigator.userAgent || navigator.vendor || '';
    const touchCapable = ('ontouchstart' in window) || navigator.maxTouchPoints > 1;
    // iPad (including iPadOS desktop masquerade) heuristics
    const isIpad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const narrow = window.innerWidth < 768; // CSS breakpoint for mobile layout
    // Treat true phones & small tablets as mobile; exclude iPad when in desktop width
    const baseMobileUA = /Mobi|Android|iPhone|iPod/i.test(ua); // deliberately excludes iPad
    // iPad counts as mobile only when narrow (portrait or small split screen)
    const effectiveMobileUA = baseMobileUA || (isIpad && narrow);
    return touchCapable && (effectiveMobileUA || narrow) && !(isIpad && !narrow);
  },
  isLandscape() {
    const mq = window.matchMedia('(orientation: landscape)');
    return mq.matches || (window.innerWidth > window.innerHeight);
  },
  update() {
    if (!this.el) return;
    const show = this.isMobile() && this.isLandscape();
    this.el.classList.toggle('is-visible', !!show);
    // Ensure hidden on non-mobile even if landscape
    if (!show) this.el.classList.remove('is-visible');
  },
  _debounce(fn, wait) {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
  }
};

export default rotateMessage;